// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

export const environment = {
  production: false,
  apiHost: process.env['NX_API_HOST'],
  trackId: process.env['NX_TRACK_ID'],
  stripePublicKey: process.env['NX_STRIPE_PUBLIC_KEY'],
  premiumPlanMaxVerifications: process.env['PREMIUM_PLAN_MAX_VERIFICATIONS'],
  vuFingerprintUrl: process.env['NX_VU_FINGERPRINT_URL']
};
